module.exports = __webpack_public_path__ + "static/media/evidence-2.e7557a25.png";